import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject } from '@ember/service';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if this.showMoreButton}}\n  <div class=\'nv-showmore\' ...attributes>\n    <a class=\'link-button\' data-test-toggle-show-more {{on \'click\' this.toggleShowMore}}>\n      <FaIcon @icon={{if this.showMore \'chevron-up\' \'chevron-down\'}} />\n    </a>\n    <a data-test-toggle-show-more-2 {{on \'click\' this.toggleShowMore}}>\n      <small class=\'nv-cap\'>\n        {{t (if this.showMore \'show less\' \'show more\')}}\n      </small>\n    </a>\n  </div>\n{{/if}}\n\n{{#if this.showMore}}\n  {{#if this.contacts}}\n    <RelatedContacts\n      @applicationController={{@applicationController}}\n      @item={{@item}}\n      @isEditable={{this.isWrapContactsEditable}}\n      @saveRelation={{this.isWrapContactsEditable}}\n      @relatedContactName={{this.contacts}}\n      @action={{this.addRelated}}\n      @actionRemove={{this.removeRelated}}\n      data-test-show-association-add-related\n      data-test-remove-related-3\n    />\n  {{/if}}\n\n  {{#if this.productsDetail}}\n    <BbField\n      @label={{concat-string this.productsDetail.total this.session.me.organization.products_name}}\n    >\n      <HasMany\n        @item={{@item}}\n        @applicationController={{@applicationController}}\n        @relatedHasMany={{this.productsDetail.hasMany}}\n        @relatedModelType=\'product\'\n        @isEditable={{this.isWrapProductsEditable}}\n        @saveRelation={{this.isWrapProductsEditable}}\n        @total={{this.productsDetail.total}}\n        @action={{this.addRelated}}\n        @actionRemove={{this.removeRelated}}\n        data-test-add-related-2\n        data-test-remove-related-4\n      />\n    </BbField>\n  {{/if}}\n\n  {{#if this.projectsDetail}}\n    <BbField\n      @label={{concat-string this.projectsDetail.total this.session.me.organization.projects_name}}\n    >\n      <HasMany\n        @item={{@item}}\n        @applicationController={{@applicationController}}\n        @relatedHasMany={{this.projectsDetail.hasMany}}\n        @relatedModelType=\'project\'\n        @isEditable={{this.isWrapProjectsEditable}}\n        @saveRelation={{this.isWrapProjectsEditable}}\n        @total={{this.projectsDetail.total}}\n        @action={{this.addRelated}}\n        @actionRemove={{this.removeRelated}}\n        data-test-add-related-3\n        data-test-remove-related-5\n      />\n    </BbField>\n  {{/if}}\n\n  {{#if this.eventsDetail}}\n    <BbField\n      @label={{concat-string this.eventsDetail.total this.session.me.organization.events_name}}\n    >\n      <HasMany\n        @item={{@item}}\n        @applicationController={{@applicationController}}\n        @relatedHasMany={{this.eventsDetail.hasMany}}\n        @relatedModelType=\'event\'\n        @isEditable={{this.isWrapEventsEditable}}\n        @saveRelation={{this.isWrapEventsEditable}}\n        @total={{this.eventsDetail.total}}\n        @action={{this.addRelated}}\n        @actionRemove={{this.removeRelated}}\n        data-test-add-related-4\n        data-test-remove-related-6\n      />\n    </BbField>\n  {{/if}}\n\n  {{#if this.workhoursDetail}}\n    <BbField\n      @label={{concat-string\n        this.workhoursDetail.total\n        this.session.me.organization.workhours_name\n      }}\n    >\n      <HasMany\n        @item={{@item}}\n        @applicationController={{@applicationController}}\n        @relatedHasMany={{this.workhoursDetail.hasMany}}\n        @relatedModelType=\'workhour\'\n        @isEditable={{this.isWrapWorkhoursEditable}}\n        @saveRelation={{this.isWrapWorkhoursEditable}}\n        @total={{this.workhoursDetail.total}}\n        @action={{this.addRelated}}\n        @actionRemove={{this.removeRelated}}\n        data-test-add-related-5\n        data-test-remove-related-7\n      />\n    </BbField>\n  {{/if}}\n\n  {{#if this.invoices}}\n    <RelatedInvoices\n      @applicationController={{@applicationController}}\n      @item={{@item}}\n      @isEditable={{this.isWrapInvoicesEditable}}\n      @saveRelation={{this.isWrapInvoicesEditable}}\n      @relatedInvoiceName={{this.invoices}}\n      @action={{this.addRelated}}\n      @actionRemove={{this.removeRelated}}\n      data-test-add-related-6\n      data-test-remove-related-8\n    />\n  {{/if}}\n\n  {{#if this.expensesDetail}}\n    <BbField\n      @label={{concat-string this.expensesDetail.total this.session.me.organization.expenses_name}}\n    >\n      <HasMany\n        @item={{@item}}\n        @applicationController={{@applicationController}}\n        @relatedHasMany={{this.expensesDetail.hasMany}}\n        @relatedModelType=\'expense\'\n        @isEditable={{this.isWrapExpensesEditable}}\n        @saveRelation={{this.isWrapExpensesEditable}}\n        @total={{this.expensesDetail.total}}\n        @action={{this.addRelated}}\n        @actionRemove={{this.removeRelated}}\n        data-test-add-related-7\n        data-test-remove-related-9\n      />\n    </BbField>\n  {{/if}}\n\n  {{#if this.payments}}\n    <BbField\n      @label={{concat-string @item.total_payments_number this.session.me.organization.costs_name}}\n    >\n      <HasMany\n        @item={{@item}}\n        @applicationController={{@applicationController}}\n        @relatedHasMany={{@item.payments}}\n        @relatedModelType=\'payment\'\n        @isEditable={{this.isWrapPaymentsEditable}}\n        @saveRelation={{this.isWrapPaymentsEditable}}\n        @total={{@item.total_payments_number}}\n        @action={{this.addRelated}}\n        @actionRemove={{this.removeRelated}}\n        data-test-add-related-8\n        data-test-remove-related-10\n      />\n    </BbField>\n  {{/if}}\n{{/if}}");

var _class, _descriptor, _descriptor2;
let ShowAssociationComponent = (_class = class ShowAssociationComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "showMore", _descriptor2, this);
    if (args.showMore !== undefined) {
      this.showMore = args.showMore;
    }
  }

  // --- Configurazione ---

  get showMoreButton() {
    return this.args.showMoreButton ?? true;
  }
  get contacts() {
    return this.args.contacts ?? 'contacts';
  }
  get products() {
    return this.args.products ?? 'products';
  }
  get projects() {
    return this.args.projects ?? 'projects';
  }
  get events() {
    return this.args.events ?? 'events';
  }
  get workhours() {
    return this.args.workhours ?? 'workhours';
  }
  get expenses() {
    return this.args.expenses ?? 'expenses';
  }
  get invoices() {
    return this.args.invoices ?? 'invoices';
  }
  get payments() {
    return this.args.payments ?? 'payments';
  }

  // --- Role-based editability ---

  get userRole() {
    return this.session.me?.role || {};
  }
  _checkRole() {
    const modelName = this.args.item?.constructor?.modelName;
    const role = this.userRole;
    if (!modelName || !role) return false;
    if (modelName === 'invoice' && this.args.item?.estimate) {
      return role.estimate_edit;
    }
    return role?.get?.(`${modelName}_edit`) || false;
  }
  get isWrapContactsEditable() {
    return this.args.contactsEditable ?? this.args.isContactsEditable ?? this._checkRole();
  }
  get isWrapProductsEditable() {
    return this.args.productsEditable ?? this.args.isProductsEditable ?? this._checkRole();
  }
  get isWrapProjectsEditable() {
    return this.args.projectsEditable ?? this.args.isProjectsEditable ?? this._checkRole();
  }
  get isWrapEventsEditable() {
    return this.args.eventsEditable ?? this.args.isEventsEditable ?? this._checkRole();
  }
  get isWrapWorkhoursEditable() {
    return this.args.workhoursEditable ?? this.args.isWorkhoursEditable ?? this._checkRole();
  }
  get isWrapInvoicesEditable() {
    return this.args.invoicesEditable ?? this.args.isInvoicesEditable ?? this._checkRole();
  }
  get isWrapExpensesEditable() {
    return this.args.expensesEditable ?? this.args.isExpensesEditable ?? this._checkRole();
  }
  get isWrapPaymentsEditable() {
    return this.args.paymentsEditable ?? this.args.isPaymentsEditable ?? this._checkRole();
  }

  // --- Detail getters (DRY pattern) ---

  _buildDetail(relationName) {
    const item = this.args.item;
    if (!item || !relationName) return null;
    return {
      hasMany: item[relationName],
      total: item[`total_${relationName}_number`]
    };
  }
  get productsDetail() {
    return this._buildDetail(this.products);
  }
  get projectsDetail() {
    return this._buildDetail(this.projects);
  }
  get workhoursDetail() {
    return this._buildDetail(this.workhours);
  }
  get eventsDetail() {
    return this._buildDetail(this.events);
  }
  get expensesDetail() {
    return this._buildDetail(this.expenses);
  }

  // --- Actions ---

  toggleShowMore() {
    this.showMore = !this.showMore;
  }
  addRelated(id) {
    if (typeof this.args.action === 'function') {
      this.args.action(id);
    }
  }
  removeRelated(id) {
    if (typeof this.args.actionRemove === 'function') {
      this.args.actionRemove(id);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showMore", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "toggleShowMore", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleShowMore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addRelated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addRelated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeRelated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeRelated"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, ShowAssociationComponent);

export { ShowAssociationComponent as default };
//# sourceMappingURL=show-association.js.map
